import { useState } from 'react'

import { Link, getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Page, PageFace, Toggle } from 'ui/components'
import { BreadCrumbs } from 'ui/temp'

import { ContactsChanges } from './ContactsChanges'
import { RelationshipChanges } from './RelationshipChanges'
import { SARChangesDetailsWebPage } from './types'

import * as SC from './styles'

const routeApi = getRouteApi('/_app/bsa/sars/$id/warnings-details')

const SARChangesDetails = () => {
  const data: SARChangesDetailsWebPage = routeApi.useLoaderData()
  const { id } = routeApi.useParams()
  const [showAll, setShowAll] = useState(true)
  const { showRelationshipChanges, showContactsChanges } = data

  return (
    <Page
      face={PageFace.SECONDARY}
      breadCrumbs={
        <BreadCrumbs
          links={[
            <Link to={routes.bank.bsa.sar.index}>SARs List</Link>,
            <Link to={routes.bank.bsa.sar.details} params={{ id: id.toString() }}>
              SAR #{id}
            </Link>,
            <>SAR Changes Details</>
          ]}
        />
      }
      subTitle="SAR Changes Details"
    >
      <SC.TitleWrapper>
        <SC.Actions>
          <Toggle value={showAll} label="Show all" onChange={() => setShowAll(!showAll)} />
        </SC.Actions>
      </SC.TitleWrapper>

      <SC.Panels>
        {showRelationshipChanges && <RelationshipChanges showAll={showAll} data={data} />}
        {showContactsChanges && <ContactsChanges showAll={showAll} data={data} />}
      </SC.Panels>
    </Page>
  )
}

export default SARChangesDetails
